const NAME = 'KLAVIYO';
const CNameMapping = {
  [NAME]: NAME,
  Klaviyo: NAME,
  klaviyo: NAME,
};

export { NAME, CNameMapping };
